export default __webpack_public_path__ + "static/media/rfc.4cca83fb.png";